import { FormAlert as ExprWorksFormAlert } from '@diagentech/exprworks-ui-components';

import { withDisplayRule } from '@/features/displayRules/withDisplayRule';

export const FormAlert = withDisplayRule(ExprWorksFormAlert);
